import { defineComponent as _defineComponent } from 'vue'
import { watch } from 'vue';
import VueMarkdown from 'vue-markdown';
import { useOpenLinkNewTab } from '@/composables';


const __default__ = {
  name: 'CookieBanner',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  isCookieDialogShown: {
    type: Boolean,
    required: true,
    default: false,
  },
  isCookieEnabled: {
    type: Boolean,
    required: true,
    default: false,
  },
  bannerDescription: {
    type: String,
    default: '',
  },
  manageBtnText: {
    type: String,
    default: '',
  },
  acceptBtnText: {
    type: String,
    default: '',
  },
},
  emits: ['toggleAllUnnecessaryCookies', 'acceptCookieConsent', 'openCookieDialog'],
  setup(__props, { emit }) {

const props = __props;




const { setTargetAttributeToLink } = useOpenLinkNewTab();

watch(() => props.bannerDescription, () => {
  setTargetAttributeToLink(['description']);
}, { immediate: true });

function deny() {
  emit('toggleAllUnnecessaryCookies');
  emit('acceptCookieConsent', false);
}

return { __sfc: true,props, emit, setTargetAttributeToLink, deny, VueMarkdown }
}

})